class Offer extends HTMLElement {
  constructor() {
    super();
    this.atc = document.querySelector("button.main-atc");
    this.buttonsPricesContainers = document.querySelectorAll('.atc-button-prices');
    this.offers = document.querySelectorAll(".product-area__offers .offer");
    this.customScalapayAmountContainer = document.querySelector('.custom-scalapay-amount');
    this.mainPricesContainers = document.querySelectorAll(".bf-price-contain");
  }

  connectedCallback() {
    this.offers.forEach((offer) => {
      offer.addEventListener("click", (e) => {
        this.offerSelected(offer);
        this.updateButtons(offer);
        this.updateMainPrices(offer);
        if(this.customScalapayAmountContainer){
          this.updateScalapayAmount(offer);
        }
      });
    });
    this.atc.addEventListener("click", (e) => {
      this.addOfferToCart(e);
    });
  }

  updateMainPrices(offer) {
    this.mainPricesContainers.forEach((priceContainer) => {
      const priceArea = priceContainer.querySelector(".price-area");
      const price = priceArea.querySelector(".current-price");
      const compareAtPrice = priceArea.querySelector(".was-price");

      if (offer.dataset.comparePrice != undefined) {
        compareAtPrice.innerHTML = offer.dataset.comparePrice;
      }
      price.innerHTML = offer.dataset.price;
    });
  }
  updateScalapayAmount(offer) {
    const price =  parseFloat(offer.dataset.price.replace("€", ""));
    const scalapayAmount = `€${(price / 3).toFixed(2)}`;
    this.customScalapayAmountContainer.innerHTML = scalapayAmount;
  }

  resetActiveOffer() {
    this.offers.forEach((offer) => {
      offer.classList.remove("offer--active");
    });
  }

  offerSelected(offer) {
    this.resetActiveOffer();
    offer.classList.add("offer--active");
  }

  updateButtons(offer) {
     this.buttonsPricesContainers.forEach((container) => {
      if(offer.dataset.comparePrice != undefined) {
        container.innerHTML = `<span class="atc-button-prices__compare-at-price"> ${offer.dataset.comparePrice}</span>${offer.dataset.price}`;
      } else {
        container.innerHTML = `${offer.dataset.price}`;
      }
    });
  }

  addOfferToCart(e) {
    if (e.cancelable) {
      e.preventDefault();
    } else {
      // console.log("L'événement n'est pas annulable.");
    }
    let formData = {
      items: [],
    };
    const offerSelected = this.querySelector(".offer--active");
    const ids = offerSelected.dataset.ids.split(",");
    const quantity = offerSelected.dataset.quantity || 1;
    const ticketsEarned = (offerSelected.dataset.ticketsEarned * quantity) || 0;
    console.log(ticketsEarned);
    const collaboration = document.querySelector('.collaboration-block-container');
    if(collaboration && collaboration.dataset.id) {
      ids.push(collaboration.dataset.id);
    }
    if(ticketsEarned == 0) {
    if(collaboration && collaboration.dataset.id){
      ids.forEach((id) => {
        formData.items.push({
          id: id,
          quantity: id == collaboration.dataset.id ? 1 : quantity,
        });
      });
    } else {
      ids.forEach((id) => {
        formData.items.push({
          id: id,
          quantity: quantity,
        });
      });
    }
  } else {
    if(collaboration && collaboration.dataset.id){
      ids.forEach((id) => {
        formData.items.push({
          id: id,
          quantity: id == collaboration.dataset.id ? 1 : quantity,
          properties: {
            "Tickets gagnés": ticketsEarned.toString(),
          },
        });
      });
    } else {
      ids.forEach((id) => {
        formData.items.push({
          id: id,
          quantity: quantity,
          properties: {
            "Tickets gagnés": ticketsEarned.toString(),
          },
        });
      });
    }
  }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        window.location.href = "/cart";
      });
  }
}
customElements.define("td-offers", Offer);
